import GeneralEdit from './GeneralEdit';

export default GeneralEdit;
